<script lang="ts" setup>
import { useRoute } from 'vue-router';

withDefaults(defineProps<{ keepAliveInclude?: string }>(), {});

const route = useRoute();
</script>

<template>
  <RouterView v-slot="{ Component }">
    <KeepAlive :include="keepAliveInclude ?? route.meta.keepAliveInclude">
      <component :is="Component" />
    </KeepAlive>
  </RouterView>
</template>
